import { useEffect, useRef } from "react";

import { useMutation, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { addStamp, deleteStamp, getStamp } from "services/CompanySettings.services";
import { toast } from "sonner";

import { queryClient } from "utils/queryClient";

export function useStamp({ templateStampPath }: { templateStampPath: string | null }) {
  const { t } = useTranslation();

  const addStampMutation = useMutation<any, Error, any>({
    mutationFn: (data) => addStamp(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companySettings"] });
      toast.success("", { description: t("profile.findings.digitalStampAdded") });
    },
  });

  const deleteStampMutation = useMutation<any, Error>({
    mutationFn: deleteStamp,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companySettings"] });
      queryClient.removeQueries({ queryKey: ["stamp"] });
      toast.success("", { description: t("profile.findings.digitalStampDeleted") });
    },
  });

  const getStampQuery = useQuery<any>({
    queryKey: ["stamp"],
    queryFn: getStamp,
    enabled: false,
  });

  const { data, isFetching } = getStampQuery;
  const stampInputRef = useRef<HTMLInputElement>(null);

  const handleStampChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) addStampMutation.mutate({ file });
  };

  useEffect(() => {
    if (templateStampPath) {
      getStampQuery.refetch();
    }
  }, [templateStampPath]);

  return { addStampMutation, deleteStampMutation, getStampQuery, data, isFetching, stampInputRef, handleStampChange };
}
